
import { useState, useEffect } from 'react';
import { useTawkTo } from '../hook/useTawkTo';

const FloatingChatButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  useTawkTo('default', true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.Tawk_API?.onLoad || window.Tawk_API?.showWidget) {
        clearInterval(interval);
        setIsReady(true);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const toggleChat = () => {
    if (!isReady || typeof window === 'undefined' || !window.Tawk_API) {
      console.warn('Tawk.to not ready yet');
      return;
    }

    if (isOpen) {
      window.Tawk_API.hideWidget();
      setIsOpen(false);
    } else {
      window.Tawk_API.showWidget();
      window.Tawk_API.maximize();
      setIsOpen(true);
    }
  };

  return (
    <button
      onClick={toggleChat}
      disabled={!isReady}
      className={`fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full 
        ${isReady ? 'bg-primary-500 hover:bg-primary-600' : 'bg-gray-400'} 
        dark:bg-primary-600 dark:hover:bg-primary-700 
        flex items-center justify-center shadow-lg transition-transform hover:scale-105`}
      aria-label="Open live chat"
    >
      <span className="text-white text-xl">💬</span>
    </button>
  );
};

export default FloatingChatButton;